import React from "react";
import { NavLink, Link } from "react-router-dom";
import moment from "moment";
import { Form, Row, Col, Input, Button } from "antd";
import ContactUsModal from "./ContactUsModal";
import { 
  InstagramOutlined, 
  FacebookOutlined,
  YoutubeOutlined 
} from "@ant-design/icons";

const Footer = (props) => {
  let menuProps = props.footerNavLinks ? props.footerNavLinks : [];
  let menuLinks = [{ title: "HOME", path: "/" }, ...menuProps].map(
    (item, i) => {
      return (
        <NavLink
          key={i}
          activeClassName="active"
          to={item.path}
          className="nav-link"
          style={{ fontSize: 14, fontWeight: "bold" }}
        >
          {item.title}
        </NavLink>
      );
    }
  );

  const handleSubscribe = () => {};

  // Consistent button style for all social media buttons
  const socialButtonStyle = {
    borderColor: "#bfbfbf",
    width: 30,
    height: 30,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 30
  };

  return (
    <Row className="Footer">
      <ContactUsModal
        showContact={props.showContact}
        changeShowContact={props.changeShowContact}
      />
      <Col
        xs={24}
        className="inner--footer"
        style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}
      >
        {menuLinks}
      </Col>

      <Col className="flex-col" style={{ gap: 4 }}>
      <div>
        <button
          onClick={props.changeShowContact}
          style={{
            background: "unset",
            border: "unset",
            cursor: "pointer",
            margin: 0,
            padding: 0
          }}
        >
          Contact Us
        </button>
        </div>
        <Link to="/advertise">Advertise</Link>
        <Link to="/termsofservice">Terms of Service</Link>
        <Link to="/privacypolicy">Privacy Policy</Link>
        <Link to="/cookiepolicy">Cookie Policy</Link>
        <Link to="/communityguidelines">Community Guidelines</Link>
        {/* <Link to="/">Cookie Settings</Link> */}
        <Link to="/donotsellmypersonalinfo">Do Not Sell/Share My Personal Information</Link>
        <Link to="/californianotice">California Notice at Collection</Link>
      </Col>

      <Col>
        <div className="blue title">SUBSCRIBE</div>
        <p style={{ paddingRight: "20px" }}>
          Subscribe to updates and newsletters to get the latest news and more.
        </p>
        <Form onSubmit={handleSubscribe}>
          <Row>
            <Col xs={16} sm={18}>
              <Form.Item
                style={{ textAlign: "left" }}
                name="email"
                rules={[
                  {
                    type: "email",
                    required: true,
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="enter email address"
                  size="large"
                  onChange={props.handleEmailChange}
                />
              </Form.Item>
            </Col>
            <Col xs={4} sm={4} offset={1}>
              <Button
                htmlType="submit"
                className="btn-bordered"
                style={{ width: 85, height: 40 }}
                type="text"
              >
                GO
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>

      <Col className="flex-row" style={{ gap: 8 }}>
        <Button
          style={socialButtonStyle}
          className="btn-bordered"
          href="https://www.instagram.com/nocapvote/"
          target="_blank"
          rel="noopener noreferrer"
          icon={<InstagramOutlined style={{ fontSize: 14 }} />}
        />
        <Button
          style={socialButtonStyle}
          className="btn-bordered"
          href="https://x.com/nocapvote"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg 
            viewBox="0 0 24 24" 
            width="14" 
            height="14" 
            fill="currentColor"
          >
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
          </svg>
        </Button>
        <Button
          style={socialButtonStyle}
          className="btn-bordered"
          href="https://www.tiktok.com/@nocapvote"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg 
            viewBox="0 0 24 24" 
            width="14" 
            height="14" 
            fill="currentColor"
          >
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
          </svg>
        </Button>
        <Button
          style={socialButtonStyle}
          className="btn-bordered"
          href="https://www.facebook.com/nocapvote"
          target="_blank"
          rel="noopener noreferrer"
          icon={<FacebookOutlined style={{ fontSize: 14 }} />}
        />
        <Button
          style={socialButtonStyle}
          className="btn-bordered"
          href="https://bsky.app/profile/nocapvote.bsky.social"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg 
            viewBox="0 0 24 24" 
            width="14" 
            height="14" 
            fill="currentColor"
          >
            <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.038.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 0 1-.415-.056c.14.018.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8Z"/>
          </svg>
        </Button>
        <Button
          style={socialButtonStyle}
          className="btn-bordered"
          href="https://www.youtube.com/@nocapvote"
          target="_blank"
          rel="noopener noreferrer"
          icon={<YoutubeOutlined style={{ fontSize: 14 }} />}
        />
      </Col>

      <Col
        xs={24}
        md={24}
        style={{
          textAlign: "center",
          borderTop: "1px solid rgb(233, 233, 233)",
          paddingTop: 16,
        }}
      >
        <div style={{ 
          fontSize: 12, 
          lineHeight: 1.7, 
          color: '#666',
          maxWidth: 1000,
          margin: '0 auto',
          padding: '0 20px'
        }}>
          <p style={{ marginBottom: 12, fontWeight: 500, color: '#333' }}>
            © 2025 No Cap Vote. All Rights Reserved.
          </p>
          
          <p style={{ marginBottom: 10 }}>
            No Cap Vote is not liable for content on external websites, which are linked for reference purposes only. 
            Your use of this website indicates acceptance of our Terms of Service and Privacy Policy. 
            No Cap Vote may receive compensation for featured products or services and use tools for functionality, 
            personalization, analytics, marketing, and advertising.
          </p>
          
          <p style={{ margin: 0 }}>
            Our website may contain links to third-party websites or display content provided by third parties. 
            Such links and content are provided for convenience, reference, and informational purposes only. 
            The inclusion of any third-party link or content does not constitute or imply any endorsement, 
            approval, sponsorship, or affiliation with our organization, or with our content, products, services, 
            causes, or viewpoints. We do not control, and assume no responsibility for the content, accuracy, 
            availability, policies, or practices of any third-party websites or materials. Access to, and use of, 
            third party content or websites is at your own risk. Such links do not authorize the use of any 
            third-party content for improper commercial purposes or in any manner that is unlawful, misleading, 
            or harmful. To the fullest extent permitted by applicable law, we disclaim all liability arising from 
            or related to the use of, or reliance on, any third-party content or websites. Third parties reserve 
            the right to withdraw permission for any link to, or from, our website at any time and at their sole 
            discretion.
          </p>
        </div>
      </Col>
    </Row>
  );
};

export default Footer;